/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export enum PortalUrlsEnum {
    PRODUCTION = 'https://portal.loadbalancer.org',
    NON_PRODUCTION = 'https://kodiak.lborg.dev'
}
